<template>
  <div class="selection-bar panel-card d-flex flex-wrap align-items-center gap-3 mb-3 px-3 py-2">
    <div class="form-check mb-0">
      <input
        ref="checkboxRef"
        :id="inputId"
        class="form-check-input"
        type="checkbox"
        :checked="allSelected"
        @change="$emit('toggle-all')"
      />
      <label class="form-check-label" :for="inputId">
        {{ selectedCount ? `${selectedCount} seleccionado${selectedCount === 1 ? '' : 's'}` : 'Seleccionar todos' }}
      </label>
    </div>
    <div v-if="selectedCount" class="d-flex flex-wrap gap-2 ms-auto">
      <slot name="actions" />
      <button type="button" class="btn btn-sm btn-outline-secondary" @click="$emit('clear')">
        Limpiar
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'

const props = defineProps({
  inputId: { type: String, required: true },
  selectedCount: { type: Number, default: 0 },
  totalCount: { type: Number, default: 0 },
})

defineEmits(['toggle-all', 'clear'])

const checkboxRef = ref(null)

const allSelected = computed(() => props.totalCount > 0 && props.selectedCount === props.totalCount)
const indeterminate = computed(() => props.selectedCount > 0 && props.selectedCount < props.totalCount)

watch([indeterminate, allSelected], () => {
  if (checkboxRef.value) {
    checkboxRef.value.indeterminate = indeterminate.value
  }
}, { immediate: true })
</script>

<style scoped>
.selection-bar {
  border: 1px solid rgba(var(--bs-primary-rgb), 0.35);
  background: rgba(var(--bs-primary-rgb), 0.08);
}
</style>
